// This one works
/**
 *
 * @param {string} selector
 * @param {CallableFunction} callback
 * @param {number} ms
 */
export function waitForSelector(selector, callback, ms = 100) {
    var interval = setInterval(function () {
        if (document.querySelector(selector)) {
            callback();
            clearInterval(interval);
        }
    }, ms);
}

export const setEqualHeight = (selector, breakpoint) => {
    const elements = document.querySelectorAll(selector);

    function init() {
        elements.forEach((element) => (element.style.height = 'auto'));
        let maxHeight = 0;

        if (window.innerWidth < breakpoint) {
            return;
        }
        // Find the tallest element
        elements.forEach((element) => {
            const height = element.offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        // Set all elements to the tallest height
        elements.forEach((element) => {
            element.style.height = maxHeight + 'px';
        });
    }

    init();
    window.addEventListener('resize', init);
};
